import prepareComponent from "@bluframe/grapple/prepareComponent";
import { memo } from "react";
import useHomeVideoReviewCard from "screens/HomeVideoReviews/Add/hooks/useHomeVideoReviewCard";
import Reviews from "./Reviews";
const usePrepareComponent = ({ actions, name, serviceName, setIMDbId }) => {
    const card = useHomeVideoReviewCard({ name, serviceName, setIMDbId });
    return {
        actions,
        ...card
    };
};
export default prepareComponent(usePrepareComponent)(memo(Reviews));
